export default {
    data () {
        return {
            paymentStatus: [
                { id: 0, label: 'ยังไม่ได้ยืนยัน' },
                { id: 1, label: 'ยืนยันแล้ว' }
            ],
            paidStatus: [
                { id: 0, label: 'ยังไม่ได้ดำเนินการ' },
                { id: 1, label: 'ดำเนินการเรียบร้อยแล้ว' }
            ],
            courierUseService: ['SCG', 'FLASH'],
            zipcodeInBKK: [
                '12000', '12110', '12120', '12130', '12140', '12150', '12160', '12170', // ปทุมธานี
                '73000', '73110', '73120', '73130', '73140', '73150', '73160', '73170', '73180', '73190', '73210', '73220', // นครปฐม
                '11000', '11110', '11120', '11130', '11140', '11150', // นนทบุรี
                '74000', '74110', '74120', '74130', // สมุทรสาคร
                '10540', '10550', '10560', '10130', '10290', '10280', '10270', // สมุทรปราการ
                '10600', '10510', '10110', '10260', '10230', '10900', '10150', '10210', '10400', '10300', '10303', '10170', '10140', '10600', '10700', '10240', '10250', '10120', '10800', '10500', '10220', '10160', '10330', '10100', '10200', '10520', '10310', '10530' // กรุงเทพมหานคร
            ]
        }
    },
    methods: {
        getPaymentStatus (paymentStatus) {
            return this.paymentStatus.filter((e) => { return e.id === paymentStatus })[0].label
        },
        getPaidStatus (paidStatus) {
            return this.paidStatus.filter((e) => { return e.id === paidStatus })[0].label
        },
        calculateServiceDeliveryCost ({ courierId, products, shippingZipcode }, { weightRate }) {
            let courierName = this.getCourier(courierId)
            let useWeightRate = weightRate[courierName.toLowerCase()]
            if (this.courierUseService.indexOf(courierName) === -1) {
                return 0
            }
            let useWeight = 0
            let costOrigin = {
                'rateBkk': 0,
                'rateUpc': 0
            }
            products.forEach((product) => {
                let actWeight = product.weight * product.quantity
                useWeight += actWeight
            })

            for (let index = 0; index < useWeightRate.length; index++) {
                if (useWeight >= parseFloat(useWeightRate[index].min) && useWeight <= parseFloat(useWeightRate[index].max)) {
                    costOrigin['rateBkk'] += parseFloat(useWeightRate[index]['rateBkk'])
                    costOrigin['rateUpc'] += parseFloat(useWeightRate[index]['rateUpc'])
                    break
                }
            }
            // useWeightRate.forEach((e) => {
            //     if (useWeight >= parseFloat(e.min) && useWeight <= parseFloat(e.max)) {
            //         costOrigin['rateBkk'] += parseFloat(e['rateBkk'])
            //         costOrigin['rateUpc'] += parseFloat(e['rateUpc'])
            //         return false
            //     }
            // })
            if (this.zipcodeInBKK.indexOf(shippingZipcode) >= 0) {
                return costOrigin['rateBkk']
            } else {
                return costOrigin['rateUpc']
            }
        },
        calculateServiceDeliveryCostLogOrder ({ courierId, actualWeight, shippingZipcode }, { weightRate }) {
            let courierName = this.getCourier(courierId)
            let useWeightRate = weightRate[courierName.toLowerCase()]
            if (this.courierUseService.indexOf(courierName) === -1) {
                return 0
            }
            // let useWeight = 0
            let costOrigin = {
                'rateBkk': 0,
                'rateUpc': 0
            }
            // products.forEach((product) => {
            //     let actWeight = product.weight * product.quantity
            //     useWeight += actWeight
            // })

            for (let index = 0; index < useWeightRate.length; index++) {
                if (actualWeight >= parseFloat(useWeightRate[index].min) && actualWeight <= parseFloat(useWeightRate[index].max)) {
                    costOrigin['rateBkk'] += parseFloat(useWeightRate[index]['rateBkk'])
                    costOrigin['rateUpc'] += parseFloat(useWeightRate[index]['rateUpc'])
                    break
                }
            }
            // useWeightRate.forEach((e) => {
            //     if (useWeight >= parseFloat(e.min) && useWeight <= parseFloat(e.max)) {
            //         costOrigin['rateBkk'] += parseFloat(e['rateBkk'])
            //         costOrigin['rateUpc'] += parseFloat(e['rateUpc'])
            //         return false
            //     }
            // })
            if (this.zipcodeInBKK.indexOf(shippingZipcode) >= 0) {
                return costOrigin['rateBkk']
            } else {
                return costOrigin['rateUpc']
            }
        }
    }
}
